/**
 * MR JERRY CLUB — wspólne API helpers.
 * Wszystkie wywołania używają `withCredentials: true` (httpOnly cookies).
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const clubApi = axios.create({
  baseURL: `${API}/api/club`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Coś poszło nie tak. Spróbuj ponownie.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export const TIERS = {
  BRONZE:   { color: '#cd7f32', label: 'Brąz' },
  SILVER:   { color: '#c0c0c0', label: 'Srebro' },
  GOLD:     { color: '#d4af37', label: 'Złoto' },
  PLATINUM: { color: '#e5e4e2', label: 'Platyna' },
};
